import getFloorBuiltElementCounts from "../../services/getters/project_getters/get_floor_built_element_counts";
import loadFloorBuiltElementCounts from "../../actions/dashboard/load_floor_built_element_counts";
import useQueryWithState from "../use_query_with_state";

const useFloorBuiltElementCounts = (projectId: string, enabled: boolean = true) => {
  return useQueryWithState(
    ["useFloorBuiltElementCounts", projectId],
    loadFloorBuiltElementCounts,
    getFloorBuiltElementCounts,
    { enabled: enabled && !!projectId, refetchOnMount: "always" },
    { projectId },
    projectId
  );
};

export default useFloorBuiltElementCounts;
